var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"save-btn",attrs:{"type":"button","icon":"","title":_vm.title},on:{"click":_vm.copyCode}},[_c('v-icon',[_vm._v(_vm._s(_vm.copied ? 'mdi-check' : 'mdi-content-copy'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }